<template>
  <sdCards title="Order Refunds">
    <template #button>
      <sdButton class="btn-signin" type="warning" @click="goRefundPage">Credit Memo</sdButton>
    </template>
    <FileCardWrap>
      <a-row :gutter="15">
        <a-col :xs="24">
          <TableWrapper class="table-responsive">
            <a-table :dataSource="tableData" :columns="tableColumns" :pagination="{ defaultPageSize: 5 }" />
          </TableWrapper>
        </a-col>
      </a-row>
    </FileCardWrap>
  </sdCards>
</template>

<script>
import { FileCardWrap } from './style';
import { TableWrapper } from '@/view/styled';
import { useStore } from 'vuex';
import { computed } from 'vue';
import { dateFormat, currencyFromCode } from '@/utility/filter';
import { useRouter } from 'vue-router';

const tableColumns = [
  {
    title: 'Refund ID',
    dataIndex: 'refund_id',
    key: 'refund_id',
  },
  {
    title: 'Refund Date',
    dataIndex: 'refund_date',
    key: 'refund_date',
  },
  {
    title: 'Order',
    dataIndex: 'order',
    key: 'order',
  },
  {
    title: 'Order Date',
    dataIndex: 'order_date',
    key: 'orde_date',
  },
  {
    title: 'Bill-to Name',
    dataIndex: 'bill_to_name',
    key: 'bill_to_name',
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
  },
  {
    title: 'Amount',
    dataIndex: 'amount',
    key: 'amount',
    align: 'left',
  },
  {
    title: 'Actions',
    dataIndex: 'action',
    key: 'action',
    width: '90px',
  },
];
export default {
  components: {
    FileCardWrap,
    TableWrapper,
  },
  setup() {
    const { state } = useStore();
    const { push } = useRouter();
    const refunds = computed(() => state.orders.refunds);
    const order = computed(() => state.orders.order);

    const goRefundPage = () => {
      push({ name: 'omni-order-refunds-create' });
    };

    const tableData = computed(() =>
      refunds.value.length
        ? refunds.value.map((item) => {
            const { entity_id, increment_id, updated_at, state, grand_total, base_currency_code } = item;

            const to = {
              name: 'omni-order-refunds-details',
              params: { id: order.value.entity_id, refundId: entity_id },
            };

            return {
              key: entity_id,
              refund_id: increment_id,
              refund_date: dateFormat(updated_at),
              order: order.value.increment_id,
              order_date: dateFormat(order.value.updated_at),
              bill_to_name: order.value.billing_address.firstname + ' ' + order.value.billing_address.lastname,
              status: state === 2 ? 'paid' : 'not paid',
              amount: grand_total ? currencyFromCode(base_currency_code) + grand_total : 0,
              action: (
                <div class="table-actions">
                  <>
                    <router-link to={to}>
                      <sdButton class="btn-icon" type="default" shape="circle">
                        <sdFeatherIcons type="edit" size="16" />
                      </sdButton>
                    </router-link>
                  </>
                </div>
              ),
            };
          })
        : [],
    );

    return {
      tableData,
      tableColumns,
      goRefundPage,
    };
  },
};
</script>
